import React from "react"
import { useFormContext } from "react-hook-form"
import styled from "styled-components"
import { Label } from "./input.styled"

const InputStyle = styled.div`
  width: 100%;

  .form-input {
    max-width: 100%;
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
    font-family: system-ui;
    font-size: 16px;
    font-weight: 500;
    border-radius: 4px;
    border-width: 1px;
    height: 64px;
  }

  .input-error {
    border-color: red;
    border-radius: 4px;
  }

  .error-message {
    color: red;
    font-size: 16px;
    font-weight: 700;
    margin-top: 6px;
  }
`

function InputArea({ label, name, validate, required, placeholder }) {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  return (
    <InputStyle>
      <Label htmlFor={name} required={required}>
        {label}
      </Label>
      <textarea
        id={name}
        placeholder={placeholder}
        {...register(name, { validate })}
        className={`form-input ${errors[name] ? "input-error" : ""}`}
      />
      {errors[name] && (
        <span
          className="error-message"
          dangerouslySetInnerHTML={{ __html: errors[name].message }}
        ></span>
      )}
    </InputStyle>
  )
}

export default InputArea
